// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 270 ? "cms" : chunkId) + "." + {"24":"5533f300","270":"a740dc7c"}[chunkId] + ".css";
};